import { createSelector } from 'reselect'
import { CoreRootState } from '../coreRoot.reducer'
import { FacebookPage, GooglePage, InstagramPage } from '@3m5/sm_publish-frontend-api/models'

export const namedRequestInProgress = createSelector(
  [
    (state: CoreRootState) => state.commonStore.requests,
    (state: CoreRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestStatus = createSelector(
  [
    (state: CoreRootState) => state.commonStore.requests,
    (state: CoreRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)?.status
  },
)

export const namedRequestData = createSelector(
  [
    (state: CoreRootState) => state.commonStore.requests,
    (state: CoreRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)

export const getInstagramNumberOfPosts = createSelector(
  (state: CoreRootState) => state.commonStore.instagramNumberOfPosts,
  (state) => state,
)

export const getTheme = createSelector(
  (state: CoreRootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: CoreRootState) => state.commonStore.user,
  (state) => state,
)

export const getLanguages = createSelector(
  (state: CoreRootState) => state.commonStore.languages,
  (state) => state,
)

export const getLicensePermissions = createSelector(
  (state: CoreRootState) => state.commonStore.licensePermissions,
  (state) => state,
)

export const getDevelopmentSystem = createSelector(
  (state: CoreRootState) => state.commonStore.developmentSystem,
  (state) => state,
)

export const getNavigationList = createSelector(
  (state: CoreRootState) => state.commonStore.navigationList,
  (state) => state,
)

export const getNavigationItem = createSelector(
  (state: CoreRootState) => state.commonStore.navigationItem,
  (state) => state,
)

export const getFacebookRedirect = createSelector(
  (state: CoreRootState) => state.commonStore.facebookRedirect,
  (state) => state,
)

export const getInstagramRedirect = createSelector(
  (state: CoreRootState) => state.commonStore.instagramRedirect,
  (state) => state,
)

export const getGoogleRedirect = createSelector(
  (state: CoreRootState) => state.commonStore.googleRedirect,
  (state) => state,
)

export const getFacebookConnectHash = createSelector(
  (state: CoreRootState) => state.commonStore.facebookConnectHash,
  (state) => state,
)

export const getInstagramConnectHash = createSelector(
  (state: CoreRootState) => state.commonStore.instagramConnectHash,
  (state) => state,
)

export const getGoogleConnectHash = createSelector(
  (state: CoreRootState) => state.commonStore.googleConnectHash,
  (state) => state,
)

export const getFacebookPages = createSelector(
  (state: CoreRootState) => state.commonStore.facebookPages,
  (state) => state,
)

export const getInstagramPages = createSelector(
  (state: CoreRootState) => state.commonStore.instagramPages,
  (state) => state,
)

export const getConnectionChanged = createSelector(
  (state: CoreRootState) => state.commonStore.connectionChanged,
  (state) => state,
)

export const getConnectedFacebookPage = createSelector(
  (state: CoreRootState) => state.commonStore.connectedFacebookPage,
  (state) => state,
)

export const getConnectedInstagramPage = createSelector(
  (state: CoreRootState) => state.commonStore.connectedInstagramPage,
  (state) => state,
)

export const getConnectedGooglePage = createSelector(
  (state: CoreRootState) => state.commonStore.connectedGooglePage,
  (state) => state,
)

export const getConnectedLinkedInPage = createSelector(
  (state: CoreRootState) => state.commonStore.connectedLinkedInPage,
  (state) => state,
)

export const getTokenChanged = createSelector(
  (state: CoreRootState) => state.commonStore.tokenChanged,
  (state) => state,
)

export const getUserPages = createSelector(
  (state: CoreRootState) => state.commonStore,
  (commonStore) => commonStore.userPages
)

export const isUserFacebookPageConnected = (id: FacebookPage['networkPageId']) => createSelector(
  (state:CoreRootState) => state.commonStore.userPages,
  (userPages) => !!userPages?.find(up => up.networkPageId === id)
)

export const isUserInstagramPageConnected = (id: InstagramPage['networkPageId']) => createSelector(
  (state:CoreRootState) => state.commonStore.userPages,
  (userPages) => !!userPages?.find(up => up.networkPageId === id)
)

export const isUserGooglePageConnected = (id: GooglePage['networkPageId']) => createSelector(
  (state:CoreRootState) => state.commonStore.userPages,
  (userPages) => !!userPages?.find(up => up.networkPageId === id)
)

export const getImprint = createSelector(
  (state: CoreRootState) => state.commonStore,
  (commonStore) => commonStore.imprint
)

export const getPnrUser = createSelector(
  (state: CoreRootState) => state.commonStore,
  (commonStore) => commonStore.pnrUser
)

export const getActiveAnnouncement = createSelector(
  (state: CoreRootState) => state.commonStore,
  (commonStore) => commonStore.activeAnnouncement
)

export const getAnnouncementTemplate = createSelector(
  (state: CoreRootState) => state.commonStore,
  (commonStore) => commonStore.announcementTemplate
)
